<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" width="500px">
    <div class="addon-image"></div>

    <h2>Köp eller ladda liftkort</h2>
    <p>{{ 'Våra liftkort är så kallade keycards. Kortet kostar 55 kr och laddas för perioden du vill åka skidor. Barn 0–6 år med hjälm åker gratis med keycard som laddas kostnadsfritt. Tips! Spara ditt keycard, det går att ladda igen vid nästa besök och fungerar både i Branäs och Kungsberget.'.replace('55', SITE_CONFIG.skipass.keycard_price) }}</p>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.container
  max-width: 340px

h1
  font-size: 24px;
  font-weight: 900;
  margin-bottom 20px

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  margin-bottom: 14px
</style>



// WEBPACK FOOTER //
// SkipassInfo.vue?b37938c2